import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core';
import { Toastr } from 'data/common';
import { FHEContainer, FHEContainerScroll, FHETitle } from 'data/components';
import { SvgSDM18HCL, SvgSDM17SPG, SvgRemote, SvgSDM18MVR, SvgUser, SvgSDM20LHT, SvgSecurity } from 'data/common/iconsvg';
import { TableDetails, TableSDM18MVR, TableRemote, TableSDM17SPG, TableSDM18HCL, TableSDM20LHT, TableSecurity } from './Table';
import FormUser from './Form/FormUser';
import { getUserDetails, updateUserDetails, resetPassword } from '../../data/Users/actions';

class UserDetail extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        getUserDetails: PropTypes.func.isRequired,
        updateUserDetails: PropTypes.func.isRequired,
        resetPassword: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        const { history, user } = this.props;

        if (user.size === 0) {
            Toastr.error(Translator.translate('generic.user.toast.notFound'));
            return history.replace('/myfhe/user');
        }
        this.getUserDetails();
    }

    getUserDetails = () => {
        const { getUserDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        getUserDetails(match.params.userId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    renderChildren = () => {
        const { user, updateUserDetails, resetPassword } = this.props;

        return (
            <Fragment>
                <FormUser key={user.get('_id')} user={user} sendDataFunc={updateUserDetails} resetPassword={resetPassword} type="update" />
                <TableDetails title={Translator.translate('general.Remote')} icon={SvgRemote} table={TableRemote} userId={user.get('_id')} />
                <TableDetails title={Translator.translate('general.SDM18HCL')} icon={SvgSDM18HCL} table={TableSDM18HCL} userId={user.get('_id')} />
                <TableDetails title={Translator.translate('general.SDM17SPG')} icon={SvgSDM17SPG} table={TableSDM17SPG} userId={user.get('_id')} />
                <TableDetails title={Translator.translate('general.SDM18MVR')} icon={SvgSDM18MVR} table={TableSDM18MVR} userId={user.get('_id')} />
                <TableDetails title={Translator.translate('general.SDM20LHT')} icon={SvgSDM20LHT} table={TableSDM20LHT} userId={user.get('_id')} />
                <TableDetails title={Translator.translate('general.Security')} icon={SvgSecurity} table={TableSecurity} userId={user.get('_id')} />
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        const { user } = this.props;

        return (
            <FHEContainer withBackIcon>
                <FHETitle title={`${user.get('lastname')} ${user.get('firstname')}`} Icon={SvgUser} />
                <FHEContainerScroll>
                    <FHEContainer
                        hasNoClassContainer
                        loading={loading}
                        error={error}
                        onClickFunc={this.getUserDetails}
                        onRender={this.renderChildren}
                    />
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        user: state.environments.myfhe.data.Users.getIn(['list', props.match.params.userId], new Map())
    };
}
const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { getUserDetails, updateUserDetails, resetPassword }), dispatch)
    )(withStyles(styles, { withTheme: true })(UserDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/details.js